import * as React from "react";
const SvgFiRrCupStraw = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 5h-7.494l.266-2.124A1 1 0 0 1 15.764 2h3.235a1 1 0 1 0 0-2h-3.235a3.006 3.006 0 0 0-2.977 2.627L12.49 5H2a1 1 0 1 0 0 2h.611l1.486 12.586A5.003 5.003 0 0 0 9.063 24h5.875a5.003 5.003 0 0 0 4.966-4.414L21.39 7h.611A1 1 0 1 0 22 5m-4.083 14.351A3 3 0 0 1 14.938 22H9.063a3 3 0 0 1-2.979-2.648L4.626 7h14.75z"
    />
  </svg>
);
export default SvgFiRrCupStraw;
